exports.Node = require("./node").Node
;var assign;
((assign = require("./resolvedpos"), exports.ResolvedPos = assign.ResolvedPos, exports.NodeRange = assign.NodeRange))
exports.Fragment = require("./fragment").Fragment
;var assign$1;
((assign$1 = require("./replace"), exports.Slice = assign$1.Slice, exports.ReplaceError = assign$1.ReplaceError))
exports.Mark = require("./mark").Mark

;var assign$2;
((assign$2 = require("./schema"), exports.Schema = assign$2.Schema, exports.NodeType = assign$2.NodeType, exports.MarkType = assign$2.MarkType))
;var assign$3;
((assign$3 = require("./content"), exports.ContentMatch = assign$3.ContentMatch))

exports.DOMParser = require("./from_dom").DOMParser
exports.DOMSerializer =  require("./to_dom").DOMSerializer



//////////////////
// WEBPACK FOOTER
// ../~/prosemirror-model/dist/index.js
// module id = 16
// module chunks = 0